<template>
    <div
        :id="id"
        class="modal fade pe-0"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="ariaLabelledby"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-slideout" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="btn-close ob1-link no-decoration"
                        data-bs-dismiss="modal"
                        aria-label="Fermer"
                        @click="clickHandler"
                    >
                        <span class="icon icon-delete" aria-hidden="true" />
                    </button>
                </div>
                <div class="modal-body">
                    <slot />
                </div>
                <div class="modal-footer">
                    <button
                        v-if="withCloseButton"
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                        @click="clickHandler"
                    >
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    props: {
        // id de la modal
        id: {
            type: String,
            required: true
        },
        // id du label qui va être utilisé pour la vocalisation (doit être présent dans le slot)
        ariaLabelledby: {
            type: String,
            required: true
        },
        withCloseButton: {
            type: Boolean,
            default: true,
            required: false
        }
    },
    methods: {
        clickHandler: function () {
            this.$emit('slide-popin-modal-click');
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables';

.modal-open .modal {
    z-index: 10000;
}

.slide-popin-modal {
    .modal-dialog .modal-header .btn-close {
        &:before {
            display: none;
        }
        display: block;
    }

    .modal-dialog {
        @media (min-width: #{map-get($grid-breakpoints, xs)}) and (max-width: #{map-get($grid-breakpoints, md)}) {
            max-width: 90%;
        }
        @media (min-width: #{map-get($grid-breakpoints, md)}) and (max-width: #{map-get($grid-breakpoints, lg)}) {
            max-width: 40%;
        }
        @media (min-width: #{map-get($grid-breakpoints, lg)}) and (max-width: #{map-get($grid-breakpoints, xl)}) {
            max-width: 32%;
        }

        @media (min-width: #{map-get($grid-breakpoints, xl)}) and (max-width: #{map-get($grid-breakpoints, xxl)}) {
            max-width: 28%;
        }

        max-width: 24%;
        height: auto;
    }

    .modal-dialog .modal-content {
        @media (min-width: #{map-get($grid-breakpoints, xs)}) and (max-width: #{map-get($grid-breakpoints, md)}) {
            padding-top: 1.5625rem;
        }
        padding-top: 2.8125rem;
        padding-right: .9375rem;
        padding-left: .9375rem;
        padding-bottom: 4.3125rem;
    }

    .modal-dialog-slideout {
        min-height: 100%;
        margin: 0 0 0 auto;
        background: #fff;
    }

    .modal.fade .modal-dialog.modal-dialog-slideout {
        -webkit-transform: translate(100%, 0) scale(1);
        transform: translate(100%, 0) scale(1);
    }

    .modal.fade.show .modal-dialog.modal-dialog-slideout {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
        display: flex;
        align-items: stretch;
        -webkit-box-align: stretch;
    }

    .modal.fade.show .modal-dialog.modal-dialog-slideout .modal-body {
        overflow: visible;
    }

    .modal-dialog-slideout .modal-content {
        border: 0;
        overflow: visible;
    }

    .modal-dialog-slideout .modal-header {
        height: 30px;
        right: 2.3125rem;
    }
    .modal-dialog-slideout .modal-footer {
        height: 30px;
    }
}

</style>
